import axios from "axios";

import {
  createDecipheriv,
  createCipheriv,
  randomBytes,
} from "crypto-browserify";

const TokenString = "";

export const callApi = async (url, method, token, body) => {
  const localToken = validateToken(localStorage.getItem("session"));
  try {
    if (process.env.REACT_APP_AAA === "true") {
      body = { data: encryptedaes256cbc(body, localToken) };
    }
  } catch (error) {
    // console.log("EREA", error);
  }


  const responsecall = await axios({
    method: method,
    url: url,
    headers: {
      Authorization: token ? "Bearer " + token : "",
      "Content-Type": "application/json",
    },
    data: JSON.stringify(body),
  });
  // console.log("EREA", responsecall);
  const json = responsecall.data;
  // console.log("EREA", json);
  if (process.env.REACT_APP_AAA === "true") {
    return await descryptedaes256cbc(json.data, localToken);
  }

  return json;
};

export const callSendFornData = async (url, token, formData) => {
  const localToken = validateToken(localStorage.getItem('session'));

  const config = {
    headers: {
      Authorization: token ? 'Bearer ' + token : '',
      'Content-Type': 'multipart/form-data', // Esencial para enviar FormData
    },
  };

  try {
    const response = await axios.post(url, formData, config);

    const json = response.data;
    if (process.env.REACT_APP_AAA === 'true') {
      return await descryptedaes256cbc(json.data, localToken);
    }

    return json;

    return response.data;
  } catch (error) {
    console.error('Error al subir la foto:', error);
    throw error;
  }
};


export const callApiInit = async (url, method, token, body) => {
  const responsecall = await axios({
    method: method,
    url: url,
    headers: {
      Authorization: token ? "Bearer " + token : "",
      "Content-Type": "application/json",
    },
    data: JSON.stringify(body),
  });

  const json = responsecall.data;

  return json;
};

export const callApiLogin = async (url, method, token, body) => {
  const localToken = validateToken(localStorage.getItem("session"));
  if (process.env.REACT_APP_AAA === "true") {
    body = {
      username: encryptedaes256cbcTextPlain(body.username, localToken),
      password: encryptedaes256cbcTextPlain(body.password, localToken),
    };
    // console.log("ENCRIPTADO", body);
  }
  const responsecall = await axios({
    method: method,
    url: url,
    headers: {
      Authorization: token ? "Bearer " + token : "",
      "Content-Type": "application/json",
    },
    data: JSON.stringify(body),
  });

  const json = responsecall.data;

  if (process.env.REACT_APP_AAA === "true") {
    return await descryptedaes256cbc(json.data, localToken);
  }

  return json;
};

export function descryptedaes256cbc(encryptedText, privateKey) {
  const encryptedArray = encryptedText.split(":");
  const iv = Buffer.from(encryptedArray[0], "hex");
  const encryptedData = Buffer.from(encryptedArray[1], "hex");
  const decipher = createDecipheriv("aes-256-ctr", Buffer.from(privateKey), iv);
  let decrypted = decipher.update(encryptedData);
  decrypted = Buffer.concat([decrypted, decipher.final()]);
  const decryptedText = decrypted.toString();
  return JSON.parse(decryptedText);
}

export function getTokenView(token) {
  return validateToken(token);
}

export function encryptedaes256cbc(data, privateKey) {
  try {
    const iv = randomBytes(16);
    // console.log(iv.toString("hex"), data, privateKey);
    const cipher = createCipheriv("aes-256-ctr", Buffer.from(privateKey), iv);
    let encrypted = cipher.update(JSON.stringify(data));
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    const encryptedText = `${iv.toString("hex")}:${encrypted.toString("hex")}`;
    // console.log(encryptedText);
    return encryptedText;
  } catch (error) {
    // console.log("EEROR", error);
  }
}

export function encryptedaes256cbcTextPlain(data, privateKey) {
  try {
    const iv = randomBytes(16);
    // console.log(iv.toString("hex"), data, privateKey);
    const cipher = createCipheriv("aes-256-ctr", Buffer.from(privateKey), iv);
    let encrypted = cipher.update(data);
    encrypted = Buffer.concat([encrypted, cipher.final()]);
    const encryptedText = `${iv.toString("hex")}:${encrypted.toString("hex")}`;
    // console.log(encryptedText);
    return encryptedText;
  } catch (error) {
    // console.log("EEROR", error);
  }
}

function validateToken(token) {
  //DES

  if (token) {
    let b = 0;
    let des = "";
    try {
      let dat = token;
      while (b < dat.length - 20) {
        des = des + dat.charAt(b);
        b = b + 21;
      }
      return des;
    } catch (error) {
      //console.log(error);
    }
  }
}


/**
 * Converts an array of objects to CSV format
 * @param {Array} data - Array of objects to convert
 * @param {Array} columns - Array of column definitions with field and headerName properties
 * @returns {string} CSV content
 * @throws {Error} If data or columns are invalid
 */
export const convertToCSV = (data, columns) => {
  // Input validation
  if (!Array.isArray(data)) {
    throw new Error('Data must be an array');
  }
  if (!Array.isArray(columns)) {
    throw new Error('Columns must be an array');
  }
  if (data.length === 0) {
    throw new Error('Data array cannot be empty');
  }
  if (columns.length === 0) {
    throw new Error('Columns array cannot be empty');
  }

  try {
    // Get headers from columns
    const headers = columns.map(col => {
      if (!col.headerName) {
        throw new Error('Each column must have a headerName property');
      }
      return col.headerName;
    });
    
    // Convert data to CSV format
    const csvContent = [
      headers.join(','),
      ...data.map(row => 
        columns.map(col => {
          if (!col.field) {
            throw new Error('Each column must have a field property');
          }
          const value = row[col.field];
          
          // Handle different data types
          if (value === null || value === undefined) {
            return '';
          }
          
          // Convert to string and handle special characters
          const stringValue = String(value);
          if (stringValue.includes(',') || stringValue.includes('"') || stringValue.includes('\n')) {
            // Escape quotes by doubling them and wrap in quotes
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return stringValue;
        }).join(',')
      )
    ].join('\n');

    return csvContent;
  } catch (error) {
    throw new Error(`Error converting to CSV: ${error.message}`);
  }
};

/**
 * Triggers a download of the provided content as a CSV file
 * @param {string} content - CSV content to download
 * @param {string} filename - Name of the file to download
 * @throws {Error} If content or filename is invalid
 */
export const downloadCSV = (content, filename) => {
  if (typeof content !== 'string') {
    throw new Error('El contenido debe ser una cadena de texto');
  }
  if (!filename) {
    throw new Error('El nombre del archivo es requerido');
  }
  if (!filename.endsWith('.csv')) {
    filename = `${filename}.csv`;
  }

  try {
    const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', filename);
    link.style.visibility = 'hidden';
    
    document.body.appendChild(link);
    link.click();
    
    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  } catch (error) {
    throw new Error(`Error al descargar el CSV: ${error.message}`);
  }
};

/**
 * Exports data to CSV and triggers download
 * @param {Array} data - Array of objects to export
 * @param {Array} columns - Array of column definitions
 * @param {string} filename - Name of the file to download
 * @returns {Promise<void>}
 */
export const exportToCSV = async (data, columns, filename) => {
  try {
    const csvContent = convertToCSV(data, columns);
    downloadCSV(csvContent, filename);
  } catch (error) {
    console.error('Error al exportar a CSV:', error);
    throw error;
  }
};
